import { render, staticRenderFns } from "./contacto.vue?vue&type=template&id=7867db7c"
import script from "./contacto.vue?vue&type=script&lang=js"
export * from "./contacto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports